import { render } from "./RelatedInfoLinksComponent.vue?vue&type=template&id=6b084870&ts=true"
import script from "./RelatedInfoLinksComponent.vue?vue&type=script&lang=ts"
export * from "./RelatedInfoLinksComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__